import { Component, Input, Output, EventEmitter } from '@angular/core';
import { KeyValueId, KeyValueSet, LocalService } from 'src/service/local.service';

@Component({
  selector: 'app-qr-generator-simple',
  templateUrl: './qr-generator-simple.component.html',
  styleUrl: './qr-generator-simple.component.scss'
})
export class QrGeneratorSimpleComponent {
  @Input() barcodeValue: string = '';
  @Input() isOpen: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() texts: KeyValueId[] = [];
  @Input() options: KeyValueSet[] = [];
  @Output() isOpenChange = new EventEmitter();
  @Output() onClose = new EventEmitter();
  @Output() onOptionSelected = new EventEmitter();

  optionsTemp: KeyValueSet[] = []; selecetdOptionKey: string = '';

  constructor(public localService: LocalService) { }


  ngOnInit(): void {
    this.onSetOptions();
  }

  onSetOptions() {
    if (this.options && this.options.length > 0) {
      this.optionsTemp = JSON.parse(JSON.stringify(this.options));
      const selectedOption = this.optionsTemp.find(x => x.isSelected);
      this.selecetdOptionKey = selectedOption ? selectedOption.key : this.optionsTemp[0].key;
    }
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onDismiss();
      } break;
      case 2: {
        this.onOptionSelected.emit({
          key: this.barcodeValue,
          value: this.selecetdOptionKey
        } as KeyValueId);
      } break;
    }
  }

  onDismiss() {
    this.isOpen = false;
    this.onClose.emit(this.isOpen);
  }
}
